import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableRow, TableHead, Table, Card, TableBody, TableCell, Typography } from '@mui/material';
import { OptimizationTableProps } from '../../../../types/summarizeTable';
import theme from '../../../../theme/theme';
import OptimizationRow from './OptimizationRow';
const OptimizationTable = ({ selectedOptions }: OptimizationTableProps) => {
  const { t } = useTranslation('optimizer');
  return (
    <Card sx={{
      mb: 8,
      border: '2px solid #e6e8eb',
      bgcolor: 'white',
      borderRadius: 1,
      boxShadow: 'none',
      transition: 'box-shadow 0.2s ease',
      '&:hover': {
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      },
    }}>
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: theme.palette.primary.main }}>
            <TableCell colSpan={3}>
              <Typography variant="h6" sx={{
                fontSize: '20px',
                fontWeight: 600,
                color: 'white',
              }}>
                {t('table.title')}
              </Typography>
            </TableCell>
            <TableCell align="right">
              <Typography variant="h6" sx={{
                fontSize: '20px',
                fontWeight: 600,
                color: 'white',
              }}>
                {t('table.averagePrice')}
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {selectedOptions.map(({ title, averagePrice, optimizationOptions }, index) => (
            <React.Fragment key={index}>
              <TableRow>
                <TableCell colSpan={3}>
                  <Typography variant="body1" sx={{
                    fontWeight: 600,
                    color: theme.palette.text.primary,
                    fontSize: '20px',
                  }}>
                    {index + 1}. {title}
                  </Typography>
                </TableCell>
                <TableCell style={{ textAlign: 'right' }}>
                  <Typography
                    variant="body1"
                    sx={{
                      textDecoration: 'line-through',
                      marginRight: 2,
                      display: 'inline-block',
                      color: 'grey',
                      fontSize: '18px',
                      fontWeight: 500,
                    }}
                  >
                    {averagePrice.toFixed(2)}$
                  </Typography>
                  <Typography variant="body1" sx={{
                    display: 'inline-block',
                    color: 'rgb(1, 147, 1)',
                    fontWeight: 700,
                    fontSize: '18px',
                  }}>
                    {optimizationOptions
                      .map((opt) =>
                        opt.optCostsResults && opt.optCostsResults.length > 0
                          ? Math.max(...opt.optCostsResults.map((res) => res.price))
                          : 0,
                      )
                      .reduce((max, price) => Math.max(max, price), 0)
                      .toFixed(2)}$
                  </Typography>
                </TableCell>
              </TableRow>
              {optimizationOptions.map((option) => (
                <OptimizationRow key={option.id} option={option} />
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
};
export default OptimizationTable;
